export const version = '0.2.0.0'



// WEBPACK FOOTER //
// ./src/version.js